import { useCallback, useState } from 'react';
import { CareCreditEnrollmentMultiStep } from '@frontend/payments-care-credit';
import { useCollectPaymentMultiContext } from '../../../collect-payment-multi.context';
import { PAYMENT_MULTI_STEP_LABELS, PAYMENT_MULTI_STEPS } from '../../../utils/steps';
import { StyledStep } from '../../atoms/styled-step';
import { CareCreditEnrollStepBodyProps } from './care-credit-enroll.types';

export const CareCreditEnrollBody = ({
  onGoBack,
  onCancel,
  onEnrollmentAccepted,
  onEnrollmentDeclined,
  onGoToMessageStep,
}: CareCreditEnrollStepBodyProps) => {
  const onComplete = useCallback(() => {
    onGoBack();
  }, [onGoBack]);

  const [stepConfig, setStepConfig] = useState({
    showHeader: true,
  });

  const { person, invoice, careCreditData, activeLocationId } = useCollectPaymentMultiContext();

  const onSetParentStepData = useCallback(({ showHeader }: { showHeader: boolean }) => {
    setStepConfig({ showHeader });
  }, []);

  return (
    <StyledStep
      id={PAYMENT_MULTI_STEPS.careCreditEnroll}
      label={PAYMENT_MULTI_STEP_LABELS[PAYMENT_MULTI_STEPS.careCreditEnroll]}
      hasInternalFooter
      showBlueHeader={true}
      hasChildStepper
      components={{
        Footer: () => null,
        Header: stepConfig.showHeader ? undefined : () => null,
      }}
    >
      <CareCreditEnrollmentMultiStep
        multiStepProps={{
          onComplete,
          onCancel,
        }}
        invoice={invoice}
        person={person}
        locationId={activeLocationId}
        careCreditData={careCreditData}
        onCancel={onCancel}
        onGoBack={onGoBack}
        onGoToMessageStep={onGoToMessageStep}
        onEnrollmentAccepted={onEnrollmentAccepted}
        onEnrollmentDeclined={onEnrollmentDeclined}
        onSetParentStepData={onSetParentStepData}
      />
    </StyledStep>
  );
};
